export default "__VITE_ASSET__BSwI3YBi__"